

const TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";
const USER_KEY = "user";
const VEHICLE_KEY = "vehicle";

// Increments on every login/logout. Async flows (school-info fetch, token
// refresh) capture it before starting and discard their result if it changed
// while in flight — a response for a dead session must never reach the UI or storage.
let sessionEpoch = 0;

export function getSessionEpoch() {
  return sessionEpoch;
}

export function bumpSessionEpoch() {
  sessionEpoch += 1;
  return sessionEpoch;
}

function getStorage(preferPersistent = true) {
  const fromLocal = localStorage.getItem(TOKEN_KEY);
  const fromSession = sessionStorage.getItem(TOKEN_KEY);
  if (preferPersistent && fromLocal) return localStorage;
  if (fromSession) return sessionStorage;
  if (fromLocal) return localStorage;
  return null;
}


export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getStoredAuth() {
  const storage = getStorage();
  if (!storage) return { token: null, user: null, vehicle: null };
  const token = storage.getItem(TOKEN_KEY);
  const userJson = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  const vehicleJson = localStorage.getItem(VEHICLE_KEY) || sessionStorage.getItem(VEHICLE_KEY);
  return {
    token,
    user: userJson ? JSON.parse(userJson) : null,
    vehicle: vehicleJson ? JSON.parse(vehicleJson) : null,
  };
}

/**
 * Store auth in one storage and clear the other.
 * @param {object} payload - { token, user?, vehicle?, keepLoggedIn }
 */
export function setStoredAuth({ token, user, vehicle, keepLoggedIn }) {
  clearSessionAuth();
  bumpSessionEpoch();
  const storage = keepLoggedIn ? localStorage : sessionStorage;
  if (token) storage.setItem(TOKEN_KEY, token);
  if (user) storage.setItem(USER_KEY, JSON.stringify(user));
  if (vehicle) storage.setItem(VEHICLE_KEY, JSON.stringify(vehicle));
  window.dispatchEvent(new Event("auth-changed"));
}

export function setStoredRefreshToken(refreshToken) {
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
}

// UI state keys that are school-specific — cleared on every login and logout
// so a new session (possibly a different tenant) never inherits stale UI state.
const UI_STATE_KEYS = [
  "busActiveTab",
  "gradeViewerActiveTab",
  "payrollEmployeeType",
  "clynox_erp_bot_visible",
  "schoolId",
];

function clearSessionAuth() {
  [localStorage, sessionStorage].forEach((s) => {
    s.removeItem(TOKEN_KEY);
    s.removeItem(USER_KEY);
    s.removeItem(VEHICLE_KEY);
    UI_STATE_KEYS.forEach((key) => s.removeItem(key));
  });
}

/** Clear token and user/vehicle from both storages (logout) */
export function clearStoredAuth() {
  clearSessionAuth();
  bumpSessionEpoch();
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  window.dispatchEvent(new Event("auth-changed"));
}
